import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { IPerformanceQuarter } from '~/core/models'
import { ForecastNumber, ForecastPercentNumber } from '~/shared/pipes'

@Component({
  selector: 'app-performance-total',
  templateUrl: './performance-total.component.html',
  styleUrl: './performance-total.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ForecastNumber, ForecastPercentNumber],
})
export class PerformanceTotalComponent {
  readonly queuer = input<IPerformanceQuarter | null>()
}
